<template>
  <div id="app">
    <header-element />
    <router-view />
    <footer-element />
  </div>
</template>

<script>
import Header from "./elements/Header.vue";
import Footer from "./elements/Footer.vue";

export default {
  components: {
    "header-element": Header,
    "footer-element": Footer
  },
  name: "App",
  created() {
    // Detecting IE
    var msie = document.documentMode;
    if (msie && (msie == 9 || msie == 10 || msie == 11)) {
      this.$store.commit("setIEValue");
    }

    this.$store.dispatch("fetchCapitalTypes");
    this.$store.dispatch("fetchProviderTypes");
    this.$store.dispatch("fetchCountries");
    this.$store.dispatch("fetchSectors");
    this.$store.dispatch("fetchCompanies");
    this.$store.commit("toggleBaseDataState");
    this.$store.dispatch("fetchproviderList");
  }
};

(function() {
  if ("performance" in window == false) {
    window.performance = {};
  }

  Date.now =
    Date.now ||
    function() {
      // thanks IE8
      return new Date().getTime();
    };

  if ("now" in window.performance == false) {
    var nowOffset = Date.now();

    if (performance.timing && performance.timing.navigationStart) {
      nowOffset = performance.timing.navigationStart;
    }

    window.performance.now = function now() {
      return Date.now() - nowOffset;
    };
  }
})();
</script>

<style>
@import "/assets/css/style.css";
</style>



// WEBPACK FOOTER //
// src/App.vue